import React from "react"
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import BankingAcknowledge from "./BankingAcknowledge.js";
import Reconciliation from "./Reconciliation.js";
import ReconciliationReport from "./ReconciliationReport.js";
import DepositeSlip from "./DepositeSlip.js";

const UpfrontPayment = () => {
  return (
    <div className="sub-tab upfront-payment-tabs">
      <Tabs
        mountOnEnter={true}
        unmountOnExit={true}
        id="uncontrolled-tab-example"
      >
        <Tab eventKey="Reconciliation" title="Reconciliation">
          <Reconciliation />
        </Tab>

        <Tab eventKey="ReconciliationReport" title="Reconciliation Report">
          <ReconciliationReport />
        </Tab>

        <Tab eventKey="BankingAcknowledge" title="Banking of Acknowledged Instruments">
          <BankingAcknowledge />
        </Tab>

        <Tab eventKey="DepositSlipReport" title="Deposit Slip Report">
          <DepositeSlip />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UpfrontPayment;
